export const style = {
  paper: {
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    height: 240,
  },
};
